<template>
	<div class="container">
		<el-form ref="form" label-width="100px" class="modify-form" :model="form" :rules="rules">
			<el-form-item label="原密码" :error="formError.old_passwd" prop="old_passwd">
				<el-input v-model="form.old_passwd" placeholder="请输入原密码"></el-input>
			</el-form-item>
			<el-form-item label="新密码" :error="formError.passwd" prop="passwd">
				<el-input v-model="form.passwd" placeholder="请输入新密码"></el-input>
			</el-form-item>
			<el-form-item label="确认新密码" :error="formError.passwd_confirmation" prop="passwd_confirmation">
				<el-input v-model="form.passwd_confirmation" placeholder="请再次输入新密码"></el-input>
			</el-form-item>
			<div style="text-align:center">
				<el-button type="primary" @click="submit" :loading="loading">保存</el-button>
			</div>
		</el-form>
	</div>
</template>

<script>
import { passwd } from "@/api/user";
export default {
	data() {
		return {
			form: {},
			loading: false,
			formError: {}
		};
	},
	computed: {
		rules() {
			return {
				old_passwd: [
					{
						required: true,
						message: "请输入原密码",
						trigger: "blur"
					}
				],
				passwd: [
					{
						required: true,
						message: "请输入新密码",
						trigger: "blur"
					}
				],
				passwd_confirmation: [
					{
						required: true,
						message: "请再次输入新密码",
						trigger: "blur"
					},
					{
						validator: (rule, value, callback) => {
							if (value !== this.form.passwd) {
								callback(new Error("两次输入密码不一致"));
							} else {
								callback();
							}
						},
						trigger: "blur"
					}
				]
			};
		}
	},
	mounted() {
		// const _this = this;
		// this.$alert("此功能暂未开启", "提示", {
		// 	confirmButtonText: "确定",
		// 	callback: action => {
		// 		_this.$router.go(-1);
		// 	}
		// });
	},
	methods: {
		submit() {
			let _this = this;
			const axiosData = { ...this.form };
			this.$refs.form.validate(valid => {
				if (valid) {
					this.loading = true;
					passwd(axiosData)
						.then(res => {
							if (res && res.code === 200) {
								this.$message({
									type: "success",
									message: "修改成功",
									duration: 1000,
									onClose() {
										_this.$router.go(-1);
									}
								});
							} else if (res && res.errors) {
								//表单格式错误
								this.formError = this.$transformError(
									res.errors
								);
							} else {
								this.$message.error(res.message);
							}
						})
						.finally(() => {
							this.loading = false;
						});
				}
			});
		}
	}
};
</script>


<style lang="scss" scoped>
.modify-form {
	margin-top: 20px;
}
</style>
